module.exports = "<svg viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" role=\"img\" aria-label=\"Plus\"><title>Plus</title><path d=\"M496 208H304V16h-96v192H16v96h192v192h96V304h192\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./image/svg/plus.svg
// module id = 380
// module chunks = 88 89